module.exports = __webpack_public_path__ + "assets/img/hill-2.92e73b4c.png";